export default __webpack_public_path__ + "static/media/Sales Force - Logo2.19b27994.png";